/* global $:false */

import countdown from 'countdown/countdown'

export default class CountdownJs {
  static init () {
    new CountdownJs().setupLocale()
  }

  setupLocale () {
    this.locale = $('html').attr('lang')
    return countdown.setLabels(this.localizedLabels(), this.localizedLabels(), ' ')
  }

  localizedLabels () {
    // See localization format here:
    // http://countdownjs.org/readme.html

    if (this.locale === 'sv') {
      return '|s|m| tim|d||||||'
    } else if (this.locale === 'en') {
      return '|s|m|h|d||||||'
    } else if (this.locale === 'fi') {
      return '|s|m|h|p||||||'
    }
  }
}
